import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Dead session (expired/invalid token after a deploy or 24h) → go sign back in
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const path = window.location.pathname;
    const onAuthPage = ["/login", "/register", "/forgot-password", "/reset-password"].some((p) => path.startsWith(p));
    if (status === 401 && !url.includes("/auth/") && !onAuthPage) {
      const next = encodeURIComponent(path + window.location.search);
      window.location.href = `/login?expired=1&next=${next}`;
      return new Promise(() => {});
    }
    return Promise.reject(err);
  }
);

export default api;
